import React, {} from "react"
import {
   FaFilePdf,
   FaUnlockAlt,
   FaVideo,
   FaImage,
   FaPlayCircle,
} from 'react-icons/fa';
import {MdAudiotrack} from 'react-icons/md';
import {IoText} from 'react-icons/io5'
import {Box, CardMedia, Typography} from '@mui/material'
import '../../../css/InfluencerUpload.css'
import MediaContentVideo from './MediaContentVideo';

export default function make_content_block(content_info, type) {
    let content_media_div_name = ""
    let content_media_div_name_text = ""
    let lock_screen_div = ""
    let locked_bool = false
    let lock_screen_style = {}
    let icon_div_name = ""
    let is_locked = (content_info['current_tier'] < content_info['tier']) && (content_info['tier'] > 0);
    if (type == 'inf_scroll'){
        lock_screen_style = {
            position: 'absolute',
            fontSize: '100px',
            top: 'calc(50% - 140px)',
            left: 'calc(50% - 50px)',
            color: 'white',
            zIndex: '101',
            display: 'flex',
            alignItems: 'center',
        }
        icon_div_name = "type_icon_inf_scroll"
        if (is_locked) {
            content_media_div_name = "inf_scroll_content_block_filtered"
            content_media_div_name_text = "inf_scroll_content_block_filtered_text"
        } else {
            content_media_div_name = "inf_scroll_content_block"
            content_media_div_name_text = "inf_scroll_content_block_text"
        }
    } else if (type == 'inf_scroll_grid'){
        lock_screen_style = {
            position: 'absolute',
            fontSize: '50px',
            top: 'calc(50% - 65px)',
            left: 'calc(50% - 25px)',
            color: 'white',
            zIndex: '101',
            display: 'flex',
            alignItems: 'center',
        }
        icon_div_name = "type_icon_inf_scroll_grid"
        if (is_locked) {
            content_media_div_name = "inf_scroll_grid_content_block_filtered"
            content_media_div_name_text = "inf_scroll_grid_content_block_filtered_text"
        } else {
            content_media_div_name = "inf_scroll_grid_content_block"
            content_media_div_name_text = "inf_scroll_grid_content_block_text"
        }
    }
    if (is_locked) {
        lock_screen_div = (
            <div style={lock_screen_style}>
                <FaUnlockAlt/>
            </div>
        )
        locked_bool = true
    } else {
        if (content_info['content_type'] == 'vid'){
            lock_screen_div = <div style={lock_screen_style}><FaPlayCircle/></div>
        }
    }
    let source_file = ""
    let file_type_div = ""
    if (content_info['content_type'] == 'img'){
        source_file = content_info['file']
        file_type_div = <div className={icon_div_name}><FaImage/></div>
    } else if (content_info['content_type'] == 'pdf'){
        source_file = content_info['thumbnail']
        file_type_div = <div className={icon_div_name}><FaFilePdf/></div>
    } else if (content_info['content_type'] == 'vid'){
        source_file = content_info['thumbnail']
        file_type_div = <div className={icon_div_name}><FaVideo/></div>
    }  else if (content_info['content_type'] == 'aud'){
        source_file = content_info['thumbnail']
        file_type_div = <div className={icon_div_name}><MdAudiotrack/></div>
    } else if (content_info['content_type'] == 'txt'){
        file_type_div = <div className={icon_div_name}><IoText/></div>
    }
    let content_media = ""
    if (content_info['content_type'] == 'txt'){
        content_media = <Typography
            className={content_media_div_name_text}
        >
            {content_info['text']}
        </Typography>
    } else if (content_info['content_type'] == 'vid' && !is_locked) {
         content_media = (
            <CardMedia
               component={MediaContentVideo}
               file={content_info['preview']}
               thumbnail={content_info['thumbnail']}
               style={{
                  height: '550px',
                  width: '100%',
                  objectFit: 'contain',
               }}
            />
         )
    } else if (content_info['content_type'] == 'aud' && !is_locked) {
         content_media = (
            <Box>
               <CardMedia
                  component="img"
                  className={content_media_div_name}
                  src={source_file}
               />
               <audio className="content_audio" onContextMenu={() => {return false;}} controls controlsList="nodownload">
                  <source src={content_info['preview']}/>
               </audio>
            </Box>
         )
   } else {
        content_media = (
            <CardMedia
                component="img"
                className={content_media_div_name}
                src={source_file}
            />
        )
    }
    return {content_media, lock_screen_div, file_type_div, locked_bool}

}
